import Select from 'react-select'

const AutoComplite = (props: any) => {
  // props
  let label = props.label ?? '';
  let firstSelect = props.firstSelect ?? '';
  let params = props.params ?? [];
  let height = props.height ?? 31

  const onChange = (valueSelect: any) => {
    props.handleChange(valueSelect)
  }

  const customStyles = {
    control: (base: any) => ({
      ...base,
      height: height,
      minHeight: 30,
      minWidth: 142,
      background: "trasparent",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      height: height,
      position: "relative",
      top: "-1px !important",
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      top: "-1px !important",
    }),
  };

  return (
    <>
      {(params &&
        <div className={`SelectBox class${height}`}>
          {((label) ? <label htmlFor="">{label}</label> : <></>)}
          <Select
            placeholder={firstSelect}
            styles={customStyles}
            options={params}
            onChange={onChange}
            value={props.selectedOption}
          />
        </div>
      )}
    </>
  )
}

export default AutoComplite